import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { createRef, useState, useEffect } from 'react';
import { useStateContext } from '../../../context/ContextProvider';
import { GrAdd } from 'react-icons/gr';


import {
    Box,
    Select,
    FormControl,
    FormLabel,
    Input,
    Flex,
    InputGroup,
    HStack,
    InputRightElement,
    useColorModeValue,
    Stack,
    useToast,
    Button,
    Text,
    Alert,
    AlertIcon,
    Spinner,
    InputLeftElement,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Checkbox,
    CheckboxGroup,

} from '@chakra-ui/react';
import axiosClient from '../../../axios-client';
import { TfiReload } from 'react-icons/tfi';
import { useTranslation } from 'react-i18next';


export default function AddUser() {
    //toast variable
    const inputColor = useColorModeValue("gray.300", "gray.600")
    const toast = useToast()
    const navigate = useNavigate()

    const emailRegex = /^[a-zA-Z][a-zA-Z0-9._-]*@[a-zA-Z]+(?:-[a-zA-Z]+)?\.[a-zA-Z]{2,}$/;
    const { t } = useTranslation();


    const [first_name, setFirstName] = useState("")
    const [last_name, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const password = createRef()

    const confirmPassword = createRef()

    const [pwd, setPwd] = useState('');

    const [message, setMessage] = useState('')
    const [showPassword, setShowPassword] = useState(false);
    const [selectedRole, setSelectedRole] = useState('')
    const [businesses, setBusinesses] = useState([]);
    const [selectedBusinesses, setSelectedBusinesses] = useState([]);

    const { user, isLoading, setIsLoading, setUser, setToken, dataSubscriptionUser, getAbonnementClient } = useStateContext()

    const handleRoleChange = (ev) => {
        setSelectedRole(ev.target.value) // update selected role when option is selected
    }

    useEffect(() => {
        axiosClient.get('/businesses/')
            .then(res => {
                setBusinesses(res.data);
            })
            .catch(() => { });
    }, []);


    ////////////////////////// VALIDATION DE MOT DE PASSE /////////////////////////////////////////
    const [passwordStrength, setPasswordStrength] = useState('');
    const [passwordColor, setPasswordColor] = useState('');

    const checkPasswordStrength = () => {
        const specialchar = /[@#$%^&+=!*_|()/."';:,?]/;
        const minLengthRegex = /^.{8,}$/;
        const startLength = /^.{2,}$/;
        const digitRegex = /\d/;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;

        let missingRequirements = [];

        if (!specialchar.test(pwd)) {
            missingRequirements.push(t("caractère spécial"));
        } else if (!lowercaseRegex.test(pwd)) {
            missingRequirements.push(t("minuscule"));
        } else if (!uppercaseRegex.test(pwd)) {
            missingRequirements.push(t("majuscule"));
        } else if (!digitRegex.test(pwd)) {
            missingRequirements.push(t("chiffres"));
        } else if (!minLengthRegex.test(pwd)) {
            missingRequirements.push(t("longueur minimale de 8 caractères"));
        }

        if (missingRequirements.length > 0) {
            const missingText = `${t("Vous avez besoin de")} ${missingRequirements.join(", ")} ${t("dans votre mot de passe.")}`;
            setPasswordStrength(missingText);
            setPasswordColor('red.500');
        } else {
            setPasswordStrength(t('Le mot de passe est correct!'));
            setPasswordColor('green');
        }
    }

    useEffect(() => {
        checkPasswordStrength();
    }, [pwd]);
    // check the password complexity
    const isPasswordValid = (password) => {
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-_@!?+])[0-9a-zA-Z\-_@!?+]{8,}$/;
        const specialchar = /[-_@!?+]/;
        const minLengthRegex = /^.{8,}$/;
        const digitRegex = /\d/;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;

        let errors = [];

        if (!minLengthRegex.test(password)) {
            errors.push(t('Le mot de passe doit comporter au moins 8 caractères.'));
        }

        if (!digitRegex.test(password)) {
            errors.push(t('Le mot de passe doit contenir au moins un chiffre.'));
        }

        if (!lowercaseRegex.test(password)) {
            errors.push(t('Le mot de passe doit contenir au moins une lettre minuscule.'));
        }

        if (!uppercaseRegex.test(password)) {
            errors.push(t('Le mot de passe doit contenir au moins une lettre majuscule.'));
        }
        if (!specialchar.test(password)) {
            errors.push(t('Le mot de passe doit contenir au moins un caractère spécial (@#$%^&+=).'));
        }
        if (password.length > 20) {
            errors.push(t('Le mot de passe ne doit pas dépasser 20 caractères.'));
        }

        if (errors.length > 0) {
            setMessage(errors[0]);
            return false;
        }

        if (!passwordRegex.test(password)) {
            setMessage(t('Le mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre minuscule , une lettre majuscule et un caractère spécial.'));
            return false;
        }

        return true;
    };

    const isEmpty = () => {
        return !last_name.trim() || !first_name.trim() || !email.trim() || !pwd.trim() || !selectedRole
    };

    const onSubmit = async ev => {
        ev.preventDefault()
        if (isLoading) return;

        const payload = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            pays: "",
            ville: "",
            code_postal: "",
            rue: "",
            tel: "",
            birthday: null,
            added_by: user.first_name + ' ' + user.last_name,
            password: pwd,
            role_client: selectedRole,
            user: user?.id,
            works_for: user.id,
            business_ids: selectedBusinesses
        }

        if (first_name.trim() === "" || last_name.trim() === "") {
            window.scrollTo(0, 0)
            setMessage(t('Veuillez remplir les champs correctement'))
            return
        }
        if (pwd !== confirmPassword.current.value) {
            window.scrollTo(0, 0);
            setMessage(t("Veuillez confirmer votre mot de passe"));
            return;
        }
        
        if (pwd.length > 0 && !isPasswordValid(pwd)) {
            window.scrollTo(0, 0);
            return;
        }
        
        if (!emailRegex.test(email)) {
            window.scrollTo(0, 0);
            setMessage(t("Veuillez entrer un email valide."));
            return;
        }

        if (parseInt(dataSubscriptionUser?.accounts_limit) !== 0 && parseInt(dataSubscriptionUser?.subscription?.accounts_count) >= parseInt(dataSubscriptionUser?.accounts_limit)) {
            toast({
                description: t("Vous avez atteint la limite des comptes de votre abonnement"),
                status: 'warning',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            });
            return
        }

        setIsLoading(true);
        try {
            const res = await axiosClient.post('clients/create_client/', payload);
            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
                return;
            }
            else if (res.data.error === 'No active subscription' || res.data.error === 'Subscription expired' || res.data.error === 'Accounts limit reached') {
                toast({
                    description: res.data.message,
                    variant: 'left-accent',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }
            else {
                toast({
                    description: t("l'utilisateur est ajouté avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: "left-accent",
                })
                getAbonnementClient()
                navigate('/utilisateurs')
            }
        } catch (err) {
            const response = err.response;
            if (response && response.data) {
                setMessage(JSON.stringify(response.data));
            } else {
                setMessage(t("Une erreur est survenue lors de l'ajout de l'utilisateur."));
            }
        } finally {
            setIsLoading(false);
        }
            //     .then(() => {
            //         axiosClient.patch(`client-subscriptions/${dataSubscriptionUser?.subscription?.id}/`, {
            //             accounts_count: parseInt(dataSubscriptionUser?.subscription?.accounts_count) + 1
            //         }).then(() => {
            //             toast({
            //                 description: t("l'utilisateur est ajouté avec succès"),
            //                 status: 'success',
            //                 duration: 2000,
            //                 isClosable: true,
            //                 position: 'bottom-right',
            //                 variant: "left-accent",
            //             })
            //             navigate('/utilisateurs')
            //         })

            //     })
            //     .catch((err) => {
            //         const response = err.response;
            //         setMessage(response.data)
            //     })
    }

    const [disableInputConfirm, setDisableInputConfirm] = useState(false)
    const [generetedPwd, setGeneretedPwd] = useState()
    const generatePassword = () => {
        const length = 10; // Length of the generated password
        const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
        const numbers = '0123456789';
        const specialCharacters = '-_@!?+';

        let newPassword = '';
        let characterSet = '';

        // Include at least one character from each set
        newPassword += uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)];
        newPassword += lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)];
        newPassword += numbers[Math.floor(Math.random() * numbers.length)];
        newPassword += specialCharacters[Math.floor(Math.random() * specialCharacters.length)];

        characterSet = uppercaseLetters + lowercaseLetters + numbers + specialCharacters;

        // Generate remaining characters randomly
        for (let i = newPassword.length; i < length; i++) {
            newPassword += characterSet[Math.floor(Math.random() * characterSet.length)];
        }

        setPwd(newPassword);
        confirmPassword.current.value = newPassword
        setGeneretedPwd(newPassword)
        setDisableInputConfirm(true)

    };


    // const [countries, setCountries] = useState([]);
    // const [selectedCountry, setSelectedCountry] = useState({});

    // useEffect(() => {
    //     const Mycountries = [];
    //     const data = countryData;
    //     for (let index = 0; index < data.countries.length; index++) {
    //         Mycountries.push({
    //             value: data.countries[index].value,
    //             label: data.countries[index].label.substring(5, 50)
    //         });
    //     }
    //     setCountries(Mycountries);
    // }, []);


    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    return (
        <Box>
            <Box w={"100%"} mt={3} >
                {/* <Text as="cite" fontSize={{ base: "18px", md: "20px", lg: "22px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span onClick={() => navigate('/utilisateurs')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Utilisateurs')}</span> / <span> {t('Ajouter un utilisateur')}</span></Text> */}
                <Breadcrumb fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                    <BreadcrumbItem>
                        <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem >
                        <BreadcrumbLink onClick={() => navigate('/utilisateurs')}>{t("Utilisateurs")}</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink>{t('Ajouter un utilisateur')}</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>
            <Flex
                direction={{ base: 'column', md: 'row' }}
                align={{ base: 'stretch', md: 'center' }}
                justify={"center"}
                p={5}
            >

                <Stack
                    bg={useColorModeValue('white', 'gray.700')}
                    rounded={'xl'}
                    p={6}
                    my={5}
                    w={{ base: '100%', md: '100%', lg: '70%', sm: '100%' }}
                >
                    {message &&
                        <Alert fontSize={"sm"} padding={2} status='error' rounded="md">
                            <AlertIcon />
                            {message}
                        </Alert>
                    }
                    <Box p={5} rounded={'lg'} w="100%" maxW="full"
                        align={'center'}
                        justify={'center'}
                    >
                        <Stack spacing={2} w={{ base: '100%', md: '100%', lg: '100%', sm: '100%' }}
                        >
                            <HStack >
                                <Box w="50%">
                                    <FormControl id="firstName" isRequired >
                                        <FormLabel ml={0.5}>{t("Nom")} </FormLabel>
                                        <Input value={last_name} onChange={(e) => setLastName(e.target.value)} name="last_name" type="text" placeholder={t('Tapez le nom')} maxLength={25} />
                                    </FormControl>
                                </Box>
                                <Box w="50%">
                                    <FormControl id="lastName" isRequired >
                                        <FormLabel ml={0.5}>{t("Prénom")}</FormLabel>
                                        <Input value={first_name} onChange={(e) => setFirstName(e.target.value)} type="text" placeholder={t('Tapez le prénom')} maxLength={25} />

                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack spacing={2}>
                                <Box w="100%">
                                    <FormControl id="email" isRequired >
                                        <FormLabel ml={0.5}>{t("Adresse email")}</FormLabel>
                                        <Input value={email} onChange={(e) => setEmail(e.target.value)} name="email" type="email" placeholder={t("Tapez l'adresse email")} maxLength={50} />
                                    </FormControl>
                                </Box>

                            </HStack>
                            <Text align={'left'} fontSize="sm" color='yellow.600'>{t('Le mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre minuscule , une lettre majuscule et un caractère spécial.')}</Text>

                            <HStack>
                                <Box w="50%">
                                    <FormControl id="password" isRequired>
                                        <FormLabel ml={0.5}>{t('Mot de passe')}</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement onClick={generatePassword} as={'Button'} >
                                                <TfiReload color='gray.300' />
                                            </InputLeftElement>
                                            <Input value={pwd} ref={password} name="password" type={showPassword ? 'text' : 'password'} onChange={(e) => setPwd(e.target.value)} onCopy={(e) => e.preventDefault()} placeholder={t('Tapez le mot de passe')} />

                                            <InputRightElement h={'full'}>

                                                <Button
                                                    variant={'ghost'}
                                                    onClick={() =>
                                                        setShowPassword((showPassword) => !showPassword)
                                                    }>
                                                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>


                                    </FormControl>

                                </Box>

                                <Box w="50%">
                                    <FormControl id="password_confirmation" isRequired>
                                        <FormLabel ml={0.5}>{t('Confirmer le mot de passe')}</FormLabel>
                                        <InputGroup>
                                            {(disableInputConfirm && pwd === generetedPwd) ?
                                                <Input ref={confirmPassword} name="confirmPassword" type="password" placeholder={t('Confirmez le mot de passe')} disabled />
                                                :
                                                <Input ref={confirmPassword} name="confirmPassword" type="password" placeholder={t('Confirmez le mot de passe')} />
                                            }
                                        </InputGroup>
                                    </FormControl>
                                </Box>
                            </HStack>
                            {pwd.length > 0 ?
                                <Text align="left" justify="left" fontSize="sm" mt={2} color={passwordColor}>{`${passwordStrength}`}</Text>

                                : ""}
                            <HStack spacing={2}>
                                <Box w={{ base: '100%', md: '50%' }}>
                                    <FormControl id="role" isRequired >
                                        <FormLabel ml={0.5}>{t("Role")}</FormLabel>
                                        <Select placeholder={t("Sélectionnez")} onChange={handleRoleChange}>

                                            <option value="ManagerClient">{t("Manager")}</option>
                                            <option value="RespoSuiviClient">{t("Centre d'appel")}</option>
                                            <option value="StockManagerClient">{t("Gestionnaire de stock")} </option>
                                        </Select>
                                    </FormControl>

                                </Box>

                            </HStack>

                            {businesses.length > 0 && (
                                <FormControl mt={4} mb={4}>
                                    <FormLabel>{t("Assigner des business")}</FormLabel>
                                    <CheckboxGroup colorScheme='blue' value={selectedBusinesses} onChange={setSelectedBusinesses}>
                                        <Stack spacing={[1, 5]} direction={['column', 'row']} wrap="wrap">
                                            {businesses.map(biz => (
                                                <Checkbox key={biz.id} value={biz.id.toString()}>{biz.name}</Checkbox>
                                            ))}
                                        </Stack>
                                    </CheckboxGroup>
                                </FormControl>
                            )}

                            <Stack direction={['column', 'row']} spacing={10} pt={2} justifyContent="end">
                                {
                                    isEmpty() ? (
                                        <Button
                                            type="submit"
                                            onClick={onSubmit}
                                            isLoading={isLoading}
                                            colorScheme="blue"
                                            isDisabled
                                            leftIcon={<GrAdd />}
                                        >
                                            {isLoading ? <Spinner size="sm" /> : t("Ajouter")}
                                        </Button>
                                    ) : (
                                        <Button
                                            type="submit"
                                            onClick={onSubmit}
                                            isLoading={isLoading}
                                            colorScheme="blue"
                                            leftIcon={<GrAdd />}
                                        >
                                            {isLoading ? <Spinner size="sm" /> : t("Ajouter")}
                                        </Button>
                                    )
                                }
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
                {/* <Stack w="50%"
                    justify="center"
                    alignItems="center"
                    p={5}
                >
                    <Image display={{ base: 'none', md: 'flex' }} src={"responsable_img"} />
                </Stack> */}
            </Flex>
        </Box>

    )
}